export enum TextFilterValueType {
  String = 1,
  Number = 2
};

(TextFilterValueType as any).__typeName = "TextFilterValueType";
